import { render, staticRenderFns } from "./executiveDetail.vue?vue&type=template&id=2efa4020&scoped=true&"
import script from "./executiveDetail.vue?vue&type=script&lang=js&"
export * from "./executiveDetail.vue?vue&type=script&lang=js&"
import style0 from "./executiveDetail.vue?vue&type=style&index=0&id=2efa4020&prod&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2efa4020",
  null
  
)

export default component.exports